// Avatar broken-image fallback.
//
// User photos live on external object storage. If a photo fails to load (dead
// storage endpoint, orphaned blob, expired URL, blocked network), the browser
// shows its broken-image glyph + alt text — ugly and confusing. This installs a
// single document-level listener that swaps any failed avatar <img> for the same
// placeholder the server renders when no photo is attached, so a storage hiccup
// degrades gracefully instead of looking broken.
//
// One global handler covers every current and future avatar render (server-rendered
// HAML across profile, sidebar, and upload surfaces) without per-site wiring.

import { PHOTO_DROP_PLACEHOLDER_HTML } from "./photo_drop"

// Map an avatar <img> class to the placeholder markup that should replace it,
// mirroring the server-rendered "no photo" fallback for that surface.
const FALLBACKS = [
  { className: "gl-profile-avatar-img", html: PHOTO_DROP_PLACEHOLDER_HTML },
  { className: "gl-sidebar-avatar-img", html: '<div class="gl-sidebar-avatar-initials"><i class="ph ph-user"></i></div>' },
];

let installed = false;

export function initAvatarFallback() {
  if (installed) return;
  installed = true;
  // Capture phase: image `error` events fire only at the target and do not bubble.
  document.addEventListener("error", handleAvatarError, true);
}

function handleAvatarError(event) {
  const img = event.target;
  if (!(img instanceof HTMLImageElement)) return;

  const match = FALLBACKS.find((fallback) => img.classList.contains(fallback.className));
  if (!match) return;

  img.insertAdjacentHTML("afterend", match.html);
  img.remove();
}
